import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useSite } from "../../context/SiteContext";
import { img } from "../../lib/api";

export const Logo = ({ site, light = true, className = "h-12 lg:h-14" }) => (
  <Link to="/" data-testid="site-logo" className={`flex items-center gap-3 ${light ? "text-white" : "text-black"}`} aria-label={`${site?.brand?.name || "Bhatkya"} home`}>
    <img src={site?.brand?.logo ? img(site.brand.logo) : "/logo.png"} alt={`${site?.brand?.name || "Bhatkya"} ${site?.brand?.name_local || "भटक्या"}`} className={`${className} w-auto ${light ? "logo-invert" : ""}`} />
  </Link>
);

export function Header() {
  const { site } = useSite();
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  useEffect(() => setOpen(false), [loc.pathname]);
  const nav = site?.nav || [];
  return (
    <header className="sticky top-0 z-50 bg-black text-white on-dark border-b border-[#333]" data-testid="site-header">
      <div className="container-x flex h-16 lg:h-20 items-center justify-between gap-6">
        <Logo site={site} />
        <nav className="hidden xl:flex items-center gap-5" aria-label="Main">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.to === "/"} data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) => `whitespace-nowrap text-[13px] font-medium tracking-wide transition-opacity hover:opacity-100 ${isActive ? "opacity-100 underline underline-offset-8" : "opacity-75"}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden xl:flex items-center gap-3">
          <a href="/#experiences" className="hidden 2xl:inline-flex whitespace-nowrap btn-ghost-light btn-sm py-2.5 px-4" data-testid="header-explore-btn">Explore Experiences</a>
          <Link to="/contact?plan=1" className="whitespace-nowrap btn-light btn-sm py-2.5 px-4" data-testid="header-plan-btn">Plan Your Trip</Link>
        </div>
        <button className="xl:hidden p-2" onClick={() => setOpen(!open)} aria-label="Toggle menu" aria-expanded={open} data-testid="mobile-menu-toggle">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <div className="xl:hidden border-t border-[#333] bg-black" data-testid="mobile-menu">
          <nav className="container-x py-6 flex flex-col gap-1" aria-label="Mobile">
            {nav.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.to === "/"} className="py-3 text-lg font-display border-b border-[#222]">{n.label}</NavLink>
            ))}
            <div className="grid grid-cols-2 gap-3 pt-5">
              <a href="/#experiences" className="btn-ghost-light">Explore</a>
              <Link to="/contact?plan=1" className="btn-light">Plan Your Trip</Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
